import { DTIProps } from '@xometry/ui';
import LogoSource from 'assets/images/logo.min.svg?url';
import { CURRENT_REGION } from 'common/config/regions/config';
import { Regions } from 'common/config/regions/types';
import routes from 'common/routes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import s from './HeaderLogo.module.less';

export const HeaderLogo: FC<DTIProps> = (props) => {
  const { 'data-testid': DTI } = props;
  const { t } = useTranslation();

  return (
    <Link data-testid={DTI} to={routes.root} className={s.link}>
      <img className={s.img} src={LogoSource} alt="logo" />
      &nbsp;for Partners
      {CURRENT_REGION !== Regions.SG ? `, ${t(`regions.${CURRENT_REGION.toLowerCase()}.full`)}` : null}
    </Link>
  );
};
